import axios from 'axios';

// Use same domain for API calls - Emergent handles routing automatically
// When deployed, both frontend and backend are on the same domain
// The /api prefix routes to backend via Kubernetes ingress
const BACKEND_URL = window.location.origin;
const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true
});
